import React from "react";

import SiteNav from "components/Redesign/SiteNav.js";
import SiteFooter from "components/Redesign/SiteFooter.js";
import { COMPANY_NAME, CONTACT_EMAIL } from "components/Redesign/legalData.js";

function Impressum() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="rd">
      <SiteNav />

      <section className="page-shell">
        <div className="wrap">
          <div className="rd-section-no">Rechtliches</div>
          <h1 className="page-shell-h1">Impressum</h1>

          <div className="legal-body">
            <h2>Anbieterin</h2>
            <p>{COMPANY_NAME}</p>

            <h2>Kontakt</h2>
            <p>
              E-Mail: <span className="legal-mail">{CONTACT_EMAIL}</span>
            </p>

            <h2>Verantwortlich für den Inhalt</h2>
            <p>Familie Bühler</p>
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
}

export default Impressum;
